module.exports = __webpack_public_path__ + "static/media/despand.ae85a886.svg";